<template>
  <div>
    <page-header houseNotes />
    <main class="body" role="main" id="main">
      <sc-placeholder tag="section" :rendering="rendering" name="digital-house-notes-layout"/>
    </main>
  </div>
</template>

<script>
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue'
import UIMixin from '~/mixins/ui'
import PageHeader from '~/components/page-header'

export default {
  name: 'HouseNotesLandingPage',

  head () {
    return {
      title: this.$t('META_TITLE_CONTENT'),
      meta: [
        { hid: 'description', name: 'description', content: this.$t('META_DESCRIPTION_CONTENT') }
      ]
    }
  },
  props: {
    rendering: {
      type: Object
    }
  },
  components: {
    scPlaceholder: Placeholder,
    PageHeader
  },
  mixins: [
    UIMixin
  ]
}
</script>

<style lang="scss" scoped>
main.body {
  background-color: $deprecated-white;

  > section,
  .recommended-wrapper {
    max-width: 1280px;
    margin: auto;
    width: 100%;
    padding: $space-060;

    @include breakpoint(small) {
      padding: $d-med;
    }

    @include tablet {
      padding: $d-large;
    }

    @include desktop {
      padding: $d-xx-large;
    }

    &:nth-of-type(2) {
      padding-top: 0;
    }
  }
}

::v-deep header.page-header div.page-header-content h1.house-notes-logo {
      margin-bottom: 0;
}

</style>
